/**
 * Environment variable accessor.
 *
 * Vite statically replaces `import.meta.env.VITE_*` references at build time.
 * Each value below becomes a string literal in the production bundle.
 */

function val(viteValue: string | undefined, fallback = ''): string {
  return viteValue !== undefined && viteValue !== '' ? viteValue : fallback;
}

export const env = {
  API_ENDPOINT: val(import.meta.env.VITE_API_ENDPOINT, 'https://api.dev.luminafactory.com/v1'),
  API_KEY: val(import.meta.env.VITE_API_KEY, ''),
  WS_ENDPOINT: val(import.meta.env.VITE_WS_ENDPOINT, 'wss://ws.api.dev.luminafactory.com'),
  COGNITO_REGION: val(import.meta.env.VITE_COGNITO_REGION, 'ap-southeast-2'),
  COGNITO_USER_POOL_ID: val(import.meta.env.VITE_COGNITO_USER_POOL_ID, ''),
  COGNITO_CLIENT_ID: val(import.meta.env.VITE_COGNITO_CLIENT_ID, ''),
} as const;
